module.exports = "<p>\n  tuberia works!\n</p>\n"